import {
    GET_LIST_PRODUCT_STATUS,
    UPDATE_SPECIFIC_PRODUCT_STATUS,
    CREATE_NEW_PRODUCT_STATUS,
    REMOVE_PRODUCT_STATUS,
    GET_PRODUCT_STATUS_ACTIVE
} from '../actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    product_status_list: [],
    product_status_active_list: [],
    pagination: {
        currentPage: 1,
        total: 0, // total records
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_PRODUCT_STATUS: {
            return {
                ...state,
                product_status_list: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            }
        }
        case GET_PRODUCT_STATUS_ACTIVE: {
            return {
                ...state,
                product_status_active_list: action.payload.data,
            }
        }
        case CREATE_NEW_PRODUCT_STATUS: {
            return {
                ...state,
                product_status_list: [action.payload, ...state.product_status_list],
                total: state.total + 1
            }
        }
        case UPDATE_SPECIFIC_PRODUCT_STATUS: {
            let index = state.product_status_list.findIndex((item) => {
                return item.id == action.payload.id;
            });
            let temp = [...state.product_status_list];
            temp[index] = action.payload;
            return { ...state, product_status_list: temp }
        }
        case REMOVE_PRODUCT_STATUS: {
            let temp = state.product_status_list.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });
            return { ...state, product_status_list: temp }
        }
        default: return { ...state };
    }
}
